import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetHubDSBSTableColumns } from './useGetHubDSBSTableColumns';
import HubDetailSBSExpandable from './HubDetailSBSExpandable';

import { TrapData } from 'api/traps/Hubs/types';
import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useScreenSize from 'hooks/Screen/useScreenSize';
import SmartBaitStationIcon from 'components/Icons/SmartRodentBaitModuleIcon';
import { TrapTableTypeLink } from 'components/TrapsTables/trapTables';

interface TableProps {
  data: TrapData[];
  isLoading: boolean;
  slug: string;
  refetch: () => void;
  deviceType?: TrapTableTypeLink;
}

const HubDetailSBSTable: React.FC<TableProps> = ({ data, isLoading, refetch, slug, deviceType }) => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const columns = useGetHubDSBSTableColumns(slug);
  const { isNotMobile } = useScreenSize();
  const { t } = useTranslation();

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <div className="bg-white">
      <FilterDataTable<TrapData>
        columns={columns}
        data={data || []}
        onChangePage={setPage}
        title={t('HubDetail.traps.SRBMTitle')}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        iconComponent={<SmartBaitStationIcon />}
        expandableRows={isNotMobile}
        expandableRowsComponent={row => <HubDetailSBSExpandable data={row.data} slug={slug} deviceType={deviceType} />}
      />
    </div>
  );
};

export default HubDetailSBSTable;
